import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useHasApiCapability } from "@advosys/component-advosys-react";
import { MessageBar, Spinner } from "@advosys/component-react";
import { useT } from "./backend-access-i18n";
import { backendActions } from "./backend-access-store";
const mapStateToProps = (state) => state.application.backendAccess;
const BackendAccessBase = (props) => {
    const { children, loading, getClientIdentityRequest, clear } = props;
    const { t } = useT();
    const clientIdentityAvailable = useHasApiCapability("common", "v2", "getClientIdentity");
    useEffect(() => {
        if (clientIdentityAvailable) {
            getClientIdentityRequest();
        }
        return () => {
            clear();
        };
    }, []);
    if (!clientIdentityAvailable)
        return _jsx(_Fragment, { children: children });
    if (loading.state === "not-started" || loading.state === "is-running")
        return _jsx(Spinner, {});
    if (loading.state === "has-finished")
        return _jsx(_Fragment, { children: children });
    return _jsx(MessageBar, { messageBarType: "error", children: t.message });
};
export const BackendAccess = connect(mapStateToProps, backendActions)(BackendAccessBase);
